import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { EventOriginEnum } from '@app/core/enums/analytics/analytics-value.enum';
import { EntityTypeEnum } from '@app/core/enums/entity-type.enum';
import { PermissionEnum } from '@app/core/enums/permissions.enum';
import { Equipment, EquipmentInput } from '@app/core/model/entities/equipments/equipment';
import { Section } from '@app/core/model/other/field-config';
import { FormStateService } from '@app/shared/components/form-builder/form-state.service';
import { GeneratesObject } from '@app/shared/interfaces/generates-object';
import { AccessManager } from '@services/managers/access.manager';
import { SectionService } from '@services/section.service';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';

@Component({
  templateUrl: './equipment-create-modal.component.html',
  providers: [FormStateService],
  standalone: false
})
export class EquipmentCreateModalComponent implements OnInit, GeneratesObject {
  public formId = 'equipment_creation_dialog';
  protected readonly EntityTypeEnum = EntityTypeEnum;

  protected eventsOrigin = EventOriginEnum.SHEET;
  public Permission = PermissionEnum;
  public permissionsForEdition = [PermissionEnum.CREATE_EQUIPMENT];
  protected missingRequiredFields$: Observable<{ code: string, label: string }[]>;
  protected form: Section[];

  protected equipmentInput: EquipmentInput;

  protected formStateService = inject(FormStateService);
  protected accessManager = inject(AccessManager);
  private sectionService = inject(SectionService);
  protected destroyRef = inject(DestroyRef);

  /**
   * Fetch possible values for state and accessible Assets and Spaces.
   */
  public ngOnInit(): void {
    this.missingRequiredFields$ = this.sectionService.getSectionsByFormCode(this.formId).pipe(
      tap(sections => this.form = sections),
      map(sections => sections.first()),
      map(section => this.sectionService.missingRequiredFields(section)),
      takeUntilDestroyed(this.destroyRef)
    );

    this.formStateService.saved$
      .pipe(
        tap(({data}) => {
          Equipment.transformPropertiesForInput(data);
          this.equipmentInput = data;
        }),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe();
  }

  /**
   * Data from the filled form.
   * @return Equipment data.
   */
  public getGeneratedObject(): EquipmentInput {
    return this.equipmentInput;
  }
}
